import React, { useState } from "react";
import { Row, Input, Button, Typography } from "antd";

const { Title } = Typography;
export default function TextField({
	label,
	value,
	editable,
	fieldId,
	updateText,
}) {
	const [editMode, setEditMode] = useState(false);
	const [fieldValue, setFieldValue] = useState(value);
	const [labelValue, setLabelValue] = useState(value);
	const toggleMode = () => {
		setEditMode((e) => !e);
	};

	const renderReadMode = () => {
		return (
			<div style={{ color: "#040E0C", fontSize: 16 }}>
				{labelValue ? labelValue : "Not Added"}
			</div>
		);
	};

	const handleUpdate = () => {
		updateText({ fieldId, fieldValue }, setLabelValue, label?.split("("));
		setEditMode(false);
	};

	const renderButtons = () => {
		return (
			<Row align="bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }}>
				<Button
					size="large"
					style={{
						color: "white",
						backgroundColor: "#363E3D",
						border: "1px solid white",
						borderRadius: 4,
					}}
					onClick={handleUpdate}
				>
					{labelValue ? "Update" : "Submit"}
				</Button>
				<Button
					size="large"
					style={{
						color: "#4F5655",
						backgroundColor: "white",
						border: "1px solid #CDCFCE",
						borderRadius: 4,
						marginLeft: "1rem",
					}}
					onClick={() => {
						setEditMode(false);
					}}
				>
					Cancel
				</Button>
			</Row>
		);
	};

	const renderEditMode = () => {
		return (
			<div
				style={{ marginTop: "1rem", display: "flex", flexDirection: "column" }}
			>
				<div>
					<Input
						size="large"
						onChange={(e) => setFieldValue(e.target.value)}
						value={fieldValue}
					/>
				</div>
				<div>{renderButtons()}</div>
			</div>
		);
	};

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				paddingTop: "1rem",
				paddingBottom: "1rem",
				borderBottom: "1px solid #E6E7E7",
				width: window.innerWidth > 900 ? "70%" : "100%",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
				}}
			>
				<div
					style={{
						fontWeight: "bold",
						color: "#4F5655",
						marginBottom: "0.5rem",
					}}
				>
					<Title level={5} type="secondary">
						{label}
					</Title>
				</div>
				{editable && !editMode && (
					<div
						onClick={toggleMode}
						style={{
							cursor: "pointer",
							color: "#0B7764",
							paddingRight: "1rem",
						}}
					>
						{value ? "Edit" : "Add"}
					</div>
				)}
			</div>
			{editMode ? renderEditMode() : renderReadMode()}
		</div>
	);
}
